import React, { useEffect, useState } from 'react';
import { X } from '@/components/icons';
import { Button } from '@/components/ui/button';

export default function QuantityKeypad({ open, label, value, decimal = true, maxDecimals, onClose, onConfirm }) {
  const [draft, setDraft] = useState('');

  useEffect(() => {
    if (open) setDraft(String(value ?? '').replace('.', ','));
  }, [open, value]);

  if (!open) return null;

  const press = (key) => {
    if (key === 'back') return setDraft((current) => current.slice(0, -1));
    if (key === ',' && (!decimal || draft.includes(','))) return;
    if (key !== ',' && draft.includes(',')) {
      const decimals = draft.split(',')[1] || '';
      if (Number.isFinite(maxDecimals) && decimals.length >= maxDecimals) return;
    }
    setDraft((current) => {
      if (key === ',' && !current) return '0,';
      if (current === '0' && key !== ',') return key;
      return `${current}${key}`;
    });
  };

  const close = (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    onClose();
  };
  const submit = () => {
    const completeDraft = draft.endsWith(',') ? draft.slice(0, -1) : draft;
    onConfirm(String(completeDraft || '').replace(',', '.'));
  };
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', decimal ? ',' : null, '0', 'back'].filter(Boolean);

  return (
    <div className="fixed inset-0 z-[100] flex items-end justify-center bg-slate-950/35" role="presentation" onPointerDown={(event) => { if (event.target === event.currentTarget) close(event); }}>
      <div data-vaul-no-drag role="dialog" aria-modal="true" aria-label={label} className="w-full max-w-md rounded-t-2xl border border-slate-200 bg-white p-3 shadow-2xl" style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))', touchAction: 'manipulation' }} onPointerDown={(event) => event.stopPropagation()} onClick={(event) => event.stopPropagation()}>
        <div className="mb-3 flex items-center justify-between gap-3">
          <div className="min-w-0 flex-1">
            <p className="truncate text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
            <div className="mt-1 min-h-12 rounded-lg border border-slate-200 bg-slate-50 px-4 py-2 text-right text-2xl font-semibold tabular-nums text-slate-950">{draft || '0'}</div>
          </div>
          <button type="button" data-vaul-no-drag onPointerDown={(event) => { event.preventDefault(); event.stopPropagation(); onClose(); }} className="inline-flex h-11 w-11 shrink-0 touch-manipulation items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 active:bg-slate-100" aria-label="Chiudi tastierino" title="Chiudi"><X className="h-4 w-4" /></button>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {keys.map((key) => <button key={key} type="button" onClick={() => press(key)} className="min-h-14 rounded-xl border border-slate-200 bg-white text-xl font-semibold text-slate-900 shadow-sm active:bg-slate-100" aria-label={key === 'back' ? 'Cancella ultima cifra' : key}>{key === 'back' ? '⌫' : key}</button>)}
        </div>
        <div className="mt-3 grid grid-cols-2 gap-2"><Button type="button" variant="outline" className="!h-12" onClick={close}>Annulla</Button><Button type="button" className="!h-12" onClick={submit}>Conferma</Button></div>
      </div>
    </div>
  );
}
